// ClockLoader.tsx
import React from "react";
import styles from "./ClockLoader.module.css";

export type ClockLoaderProps = {
  className?: string;
  style?: React.CSSProperties;
  sizePx?: number; // default 30
  "aria-label"?: string;
};

export default function ClockLoader({
  className,
  style,
  sizePx = 30,
  ...rest
}: ClockLoaderProps) {
  return (
    <div
      className={[styles.clockLoader, className].filter(Boolean).join(" ")}
      style={{ ...(style || {}), ["--clockSize" as any]: `${sizePx}px` }}
      role="img"
      aria-label={(rest as any)["aria-label"] ?? "Loading"}
      {...rest}
    >
      <div className={`${styles.hand} ${styles.hour}`} />
      <div className={`${styles.hand} ${styles.minute}`} />
    </div>
  );
}
